// GENERATED by scripts/icons/generate_icons.py. Do not edit by hand.
import { createIcon } from "./createIcon";

export const ChevronDownIcon = /*#__PURE__*/ createIcon("ChevronDown", "M15.85 7.65c.2.2.2.5 0 .7l-5.46 5.49a.55.55 0 0 1-.78 0L4.15 8.35a.5.5 0 1 1 .7-.7L10 12.8l5.15-5.16c.2-.2.5-.2.7 0");
